export const PHOTO_GUIDELINE_MESSAGE_IDS = [
  'PhotoGuidelines.frontBack',
  'PhotoGuidelines.frameAndGrip',
  'PhotoGuidelines.damage',
  'PhotoGuidelines.quality',
];
